/* AspireArtisans article: table of contents from H2s, scrollable tables, buy-button events. Page reads fine without it. */
(function () {
  'use strict';
  var body = document.querySelector('[data-aa-body]');
  if (!body) return;
  var SKIP = '.aa-takeaways, .aa-pcard, .aa-sources, .aa-toc';

  function slug(t) { return t.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section'; }

  Array.prototype.forEach.call(body.querySelectorAll('table'), function (t) {
    if (t.parentElement.classList.contains('aa-table')) return;
    var wrap = document.createElement('div');
    wrap.className = 'aa-table';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-label', 'Table, scroll sideways for more');
    t.parentNode.insertBefore(wrap, t);
    wrap.appendChild(t);
  });

  var heads = Array.prototype.filter.call(body.querySelectorAll('h2'), function (h) { return !h.closest(SKIP); });
  if (heads.length >= 3) {
    var used = {};
    var items = heads.map(function (h) {
      var id = h.id || slug(h.textContent);
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      return li;
    });
    var toc = document.createElement('details');
    toc.className = 'aa-toc';
    if (window.matchMedia('(min-width: 990px)').matches) toc.open = true;
    var sum = document.createElement('summary');
    sum.textContent = 'In this guide';
    var ol = document.createElement('ol');
    items.forEach(function (li) { ol.appendChild(li); });
    toc.appendChild(sum);
    toc.appendChild(ol);
    // after the answer / takeaways boxes when present, else before the first H2
    var after = body.querySelector('.aa-takeaways') || body.querySelector('.aa-answer');
    if (after) after.parentNode.insertBefore(toc, after.nextSibling); else heads[0].parentNode.insertBefore(toc, heads[0]);
  }

  body.addEventListener('click', function (e) {
    var a = e.target.closest('[data-aa-cta]');
    if (!a) return;
    var detail = { button: a.getAttribute('data-aa-cta'), article: location.pathname };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('aa_article_cta', detail); } catch (x) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'aa_article_cta', detail); } catch (x) {}
  });
})();
